import React, { useState } from "react";
import axios from "axios";
import { calculateProfitLoss } from "../../services/investmentService";

export default function ProfitLoss() {
  const [rates, setRates] = useState({
    goldRate: "",
    silverRate: "",
  });

  const [result, setResult] = useState(null); // { type: "profit" | "loss", cash: number }
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setRates({ ...rates, [e.target.name]: e.target.value });
  };

  const fetchProfitLoss = async () => {
    if (!rates.goldRate || !rates.silverRate) {
      alert("Please enter gold and silver rates");
      return;
    }

    try {
      setLoading(true);

      const { data } = await calculateProfitLoss({
        currentGoldRate: rates.goldRate,
        currentSilverRate: rates.silverRate,
      });
      // normalize the response
      setResult({
        type: data.status?.toLowerCase(),
        cash: data.value,
      });
      // Expected:
      // { type: "profit", cash: 5000 }
      // OR
      // { type: "loss", cash: 3000 }
    } catch (err) {
      console.error(err);
      alert("Error fetching profit/loss");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container bgCustomProfit">
      <div className="row mt-5 my-4 py-3">
        {/* Header */}
        <div className="col-12 py-3 profitCustomHeader text-center">
          <i className="fa-solid fa-chart-pie text-light me-2" />
          Business Profit / Loss
        </div>

        {/* ================= Rates Input ================= */}
        <div className="col-12 mt-4">
          <div className="card p-4 shadow-sm">
            <h5 className="mb-3">
              <i className="fa-solid fa-coins me-2 text-warning" />
              Enter Current Market Rates
            </h5>

            <div className="row">
              {/* Gold Rate */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Gold Rate (per gram)</label>
                <div className="input-group">
                  <span className="input-group-text bg-warning text-dark">
                    <i className="fa-solid fa-gem" />
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    name="goldRate"
                    value={rates.goldRate}
                    onChange={handleChange}
                    placeholder="Enter gold rate"
                  />
                </div>
              </div>

              {/* Silver Rate */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Silver Rate</label>
                <div className="input-group">
                  <span className="input-group-text bg-secondary text-light">
                    <i className="fa-solid fa-coins" />
                  </span>
                  <input
                    type="number"
                    className="form-control"
                    name="silverRate"
                    value={rates.silverRate}
                    onChange={handleChange}
                    placeholder="Enter silver rate"
                  />
                </div>
              </div>
            </div>

            <button
              className="btn btn-dark w-100 mt-2"
              onClick={fetchProfitLoss}
              disabled={loading}
            >
              {loading ? "Calculating..." : "Calculate Profit / Loss"}
            </button>
          </div>
        </div>

        {/* ================= Result ================= */}
        <div className="col-12 mt-1">
          {!result ? (
            <div className="text-center text-muted">
              <i className="fa-solid fa-circle-info me-2" />
              Enter current rates to see business profit or loss
            </div>
          ) : (
            <div
              className={`card p-4 text-center shadow ${
                result.type === "profit" ? "border-success" : "border-danger"
              }`}
            >
              <h4
                className={`mb-3 ${
                  result.type === "profit" ? "text-success" : "text-danger"
                }`}
              >
                <i
                  className={`fa-solid ${
                    result.type === "profit"
                      ? "fa-arrow-trend-up"
                      : "fa-arrow-trend-down"
                  } me-2`}
                />
                {result.type === "profit" ? "Profit" : "Loss"}
              </h4>

              <h2 className="fw-bold">
                Rs. {Number(result.cash).toLocaleString()}
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
